import React, { FC, useState } from "react";
import { Button, Modal } from "@telia/teddy";
import _forEach from "lodash/forEach";
import _get from "lodash/get";
import _groupBy from "lodash/groupBy";
import _isEmpty from "lodash/isEmpty";
import _mapValues from "lodash/mapValues";
import { useDispatch } from "react-redux";
import { Discount } from "../../../../../../models";
import { addWebdealAccessory } from "../../../state/actions/cartActions";
import TEXT from "../../../text-consts";
import WebdeaList from "../../organisms/WebdealList/WebdealList";
import "./WebdealModal.less";

interface WebdealModalProps {
    cartItemId?: string;
    onContinue: (error?: { error: string }) => void;
    webdeals: Discount[];
}

const WebdealModal: FC<WebdealModalProps> = ({ onContinue, cartItemId, webdeals }) => {
    const selectedWebdeals = webdeals.map((_w, i) => i === 0);
    const [selectedVariants, setSelectedVariants] = useState(
        webdeals.map((webdeal) => webdeal.additionalProducts.variants[0]),
    );
    const [selectedVariantsByFamily, setSelectedVariantsByFamily] = useState(
        webdeals.map((webdeal) => {
            if (!webdeal.multipleOptionsOneChoicePerFamily) return {};
            const grouped = _groupBy(webdeal.additionalProducts.variants, "modelSlug");
            return _mapValues(grouped, (variants) => variants[0]);
        }),
    );
    const dispatch = useDispatch();

    const handleOnContinue = () => {
        const skus: string[] = [];

        _forEach(webdeals, (webdeal, i) => {
            if (!selectedWebdeals[i]) return;

            if (webdeal.multipleOptionsOneChoicePerFamily) {
                Object.values(selectedVariantsByFamily[i]).forEach((variant) => {
                    if (!_isEmpty(variant?.sku)) {
                        skus.push(variant.sku);
                    }
                });
            } else if (!_isEmpty(_get(selectedVariants[i], "sku"))) {
                skus.push(selectedVariants[i].sku);
            }
        });

        if (_isEmpty(skus)) {
            onContinue();
        }

        const firstSelectedWebdeal = webdeals.find((_webdeal, i) => selectedWebdeals[i]);
        const discountCode = firstSelectedWebdeal ? firstSelectedWebdeal.code : undefined;

        dispatch(addWebdealAccessory(skus, undefined, true, cartItemId, discountCode))
            .then(() => {
                onContinue();
            })
            .catch((err: string) => {
                onContinue({ error: err });
            });
    };

    const handleOnClose = () => {
        // Remove all webdeals
        dispatch(addWebdealAccessory([], undefined, true, cartItemId))
            .then(() => {
                onContinue();
            })
            .catch((err: string) => {
                onContinue({ error: err });
            });
    };

    return (
        <Modal open>
            <Modal.Overlay className="webdeal-modal">
                <Modal.Content className="webdeal-modal__content">
                    <Modal.Group variant="title" className="webdeal-modal__heading">
                        <Modal.Title>{TEXT.MODAL.WEBDEAL.HEADING}</Modal.Title>
                        <Modal.Description className="webdeal-modal__description">
                            {TEXT.MODAL.WEBDEAL.DESCRIPTION}
                        </Modal.Description>
                    </Modal.Group>
                    <Modal.Close slot="floating" aria-label="lukk" />
                    {webdeals.length > 0 && (
                        <WebdeaList
                            webdeals={webdeals}
                            selectedVariants={selectedVariants}
                            setSelectedVariants={setSelectedVariants}
                            selectedVariantsByFamily={selectedVariantsByFamily}
                            setSelectedVariantsByFamily={setSelectedVariantsByFamily}
                        />
                    )}
                    <Modal.Group className="webdeal-modal__buttons" variant="action">
                        <Modal.Close slot="content">
                            <Button variant="secondary" onClick={handleOnClose}>
                                {TEXT.MODAL.WEBDEAL.CLOSE}
                            </Button>
                        </Modal.Close>
                        <Button onClick={handleOnContinue} variant="primary">
                            {TEXT.MODAL.WEBDEAL.SUBMIT}
                        </Button>
                    </Modal.Group>
                </Modal.Content>
            </Modal.Overlay>
        </Modal>
    );
};

export default WebdealModal;
